import React from 'react'

export default props => (
  <svg viewBox="0 0 14 16" {...props}>
    <path d="M4.66666667,7.2 L3.11111111,7.2 L3.11111111,8.8 L4.66666667,8.8 L4.66666667,7.2 Z M7.77777778,7.2 L6.22222222,7.2 L6.22222222,8.8 L7.77777778,8.8 L7.77777778,7.2 Z M10.8888889,7.2 L9.33333333,7.2 L9.33333333,8.8 L10.8888889,8.8 L10.8888889,7.2 Z M12.4444444,1.6 L11.6666667,1.6 L11.6666667,0 L10.1111111,0 L10.1111111,1.6 L3.88888889,1.6 L3.88888889,0 L2.33333333,0 L2.33333333,1.6 L1.55555556,1.6 C0.692222222,1.6 0.00777777778,2.32 0.00777777778,3.2 L0,14.4 C0,15.28 0.692222222,16 1.55555556,16 L12.4444444,16 C13.3,16 14,15.28 14,14.4 L14,3.2 C14,2.32 13.3,1.6 12.4444444,1.6 Z M12.4444444,14.4 L1.55555556,14.4 L1.55555556,5.6 L12.4444444,5.6 L12.4444444,14.4 Z" />
  </svg>
)



// WEBPACK FOOTER //
// ./src/Assets/Images/icons/calendar.js